import styled from 'styled-components';

export const SuccessBody = styled.div`
  padding: 20px 40px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media all and (max-width: 600px) {
    padding: 15px;
    min-height: calc(100vh - 140px);
  }
`;
export const SuccessTitle = styled.p`
  font-size: 24px;
  font-weight: 700;
  text-align: center;
  font-family: 'Factor A', 'DM Sans', sans-serif;
  margin-bottom: 0;
  color: #333030;
`;

export const SuccessSubtitle = styled.p`
  font-size: 18px;
  font-weight: 400;
  text-align: center;
  color: #736967;
  font-family: 'Factor A', 'DM Sans', sans-serif;
  text-align: center;
  line-height: 24px;
`;